// extracted by mini-css-extract-plugin
export var askAiIcon = "_qa-9";
export var container = "_qa-0";
export var groupSeparator = "_qa-a";
export var highlight = "_qa-4";
export var resultIcon = "_qa-5";
export var resultItem = "_qa-7";
export var resultSubtitle = "_qa-3";
export var resultTitle = "_qa-2";
export var resultsList = "_qa-1";
export var searchGroup = "_qa-6";
export var selected = "_qa-8";